import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

type EmptyStateSize = "small" | "medium" | "large";

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  height?: number;
  size?: EmptyStateSize;
}

const getSizeConfig = (size: EmptyStateSize) => {
  switch (size) {
    case "small":
      return {
        iconSize: 64,
        titleVariant: "h6" as const,
        descriptionVariant: "body2" as const,
      };
    case "medium":
      return {
        iconSize: 80,
        titleVariant: "h5" as const,
        descriptionVariant: "body1" as const,
      };
    case "large":
      return {
        iconSize: 96,
        titleVariant: "h4" as const,
        descriptionVariant: "h6" as const,
      };
    default:
      return {
        iconSize: 64,
        titleVariant: "h6" as const,
        descriptionVariant: "body2" as const,
      };
  }
};

export const EmptyState = ({
  title = "No data found",
  description = "No data available for this company at this time",
  icon,
  height = 360,
  size = "small",
}: EmptyStateProps) => {
  const sizeConfig = getSizeConfig(size);

  const defaultIcon = (
    <TrendingUpIcon
      sx={{
        fontSize: sizeConfig.iconSize,
        mb: 2,
        opacity: 0.5,
      }}
    />
  );

  return (
    <Box
      sx={{
        height,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "text.secondary",
      }}
    >
      {icon || defaultIcon}
      <Typography variant={sizeConfig.titleVariant} gutterBottom>
        {title}
      </Typography>
      <Typography variant={sizeConfig.descriptionVariant} textAlign="center">
        {description}
      </Typography>
    </Box>
  );
};
